import { MediaHelpers } from '@wajeez-web/core/api';
import React from 'react';

import {
  BaseComponentProps,
  useComponentData,
} from '../../helpers/contentHooks';
import { ClickableComponentLayout } from '../../layouts/ClickableComponentLayout';
import { TextTrimmer } from '../../layouts/TextTrimmer';

export interface CircleListItemParameters {
  image: string | null;
  description: string | undefined;
}

export const CircleListItem = React.forwardRef<
  HTMLDivElement,
  BaseComponentProps
>(({ component, context, isLastSibling }, ref) => {
  const { getParameterValue, content, isLockedContent } =
    useComponentData<CircleListItemParameters>(component, context);

  const image = getParameterValue('image');
  const description = getParameterValue('description');

  return (
    <ClickableComponentLayout content={content}>
      <div
        ref={ref}
        className={`w-full py-4 sm:py-0 flex sm:flex-col items-start justify-start`}
      >
        <div
          style={{
            backgroundImage:
              'url(' + MediaHelpers.getPublicMediaById(image) + ')',
          }}
          className={`relative h-[94px] sm:h-[150px] w-[94px] sm:w-auto min-w-[94px] sm:min-w-[150px] border sm:border-none bg-cover bg-center bg-no-repeat mb-[4px] rounded-full`}
        >
          {isLockedContent && (
            <div className="w-[25px] h-[25px] absolute bottom-[10px] left-[10px]">
              <img
                src="../../assets/images/lock.png"
                alt="lock"
                className="block w-full h-full"
              />
            </div>
          )}
        </div>
        <div className="self-stretch ps-2 sm:px-0 sm:pt-2 flex flex-col justify-center items-start">
          <div className="text-[15px] pb-[3px] font-medium sm:font-bold sm:text-[#545454]">
            <TextTrimmer textInput={content?.title} linesNumber={2} />
          </div>
          <div className="text-[12px] text-[rgba(60,_60,_67,_0.6)] dark:text-dark-light sm:text-[#545454]">
            <TextTrimmer textInput={description} linesNumber={3} />
          </div>
        </div>
      </div>
    </ClickableComponentLayout>
  );
});
